import { render, staticRenderFns } from "./table-element.vue?vue&type=template&id=4e4ca8b0&scoped=true&"
import script from "./table-element.vue?vue&type=script&lang=js&"
export * from "./table-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ca8b0",
  null
  
)

export default component.exports